import { QueryParam } from "../../../types/api/generic.type";
import {
  GetPotentialMatrixResponse,
  GetPotentialMatrixStatsResponse,
} from "../../../types/api/potentialMatrix.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const PotentialMatrixService = {
  async get(
    queryParams: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetPotentialMatrixResponse> {
    const params = queryParams ? createQueryParamString(queryParams, true) : "";
    const response = await httpClient.get<GetPotentialMatrixResponse>(
      `v1/potential-matrix${params}`,
      { signal },
    );
    return response;
  },
  async getStats(
    queryParams: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetPotentialMatrixStatsResponse> {
    const params = queryParams ? createQueryParamString(queryParams, true) : "";
    const response = await httpClient.get<GetPotentialMatrixStatsResponse>(
      `v1/potential-matrix/stats${params}`,
      { signal },
    );
    return response;
  },
};

export default PotentialMatrixService;
